import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback?.();
    this.#wireLoadMore();
  }

  #wireLoadMore() {
    const loadMoreBtn = this.querySelector('[data-action="load-more"]');
    if (!loadMoreBtn) {
      return;
    }

    const grid = this.querySelector('[ref="grid"]');
    if (!grid) {
      return;
    }

    let isLoading = false;
    const setLoading = (loading) => {
      isLoading = loading;
      loadMoreBtn.disabled = loading;
      loadMoreBtn.setAttribute('aria-busy', String(loading));
      loadMoreBtn.textContent = loading
        ? (this.dataset.labelLoading || 'Loading…')
        : (this.dataset.labelLoadMore || 'Load more');
    };

    const appendNextPage = async (nextUrl) => {
      try {
        setLoading(true);
        const res = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[ref="grid"]');
        if (!nextGrid) throw new Error('Next grid not found');

        // Append new cards
        const cards = nextGrid.querySelectorAll('[ref="cards[]"]');
        cards.forEach((card) => grid.appendChild(card));

        // Update nextUrl or hide button if last page
        const nextBtn = doc.querySelector('[data-action="load-more"]');
        if (nextBtn && nextBtn.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          setLoading(false);
        } else {
          loadMoreBtn.closest('.blog-posts__load-more-wrapper')?.remove();
        }
      } catch {
        setLoading(false);
      }
    };

    loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (isLoading) return;
      const nextUrl = loadMoreBtn.dataset.nextUrl || loadMoreBtn.getAttribute('href');
      if (!nextUrl) {
        return;
      }
      appendNextPage(nextUrl);
    });
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
